<div [matTooltip]="'Insert widget'" [matTooltipPosition]="'before'">
  <button
    mat-icon-button
    [class.active]="active"
    [y42Permission]="state.isCanvasEditable"
    [permissionTooltip]="'You do not have permission to edit the asset'"
    [intercomTarget]="'toolbar-insert-widget'"
    (click)="selectTool.emit()"
  >
    <mat-icon>insert_chart_outlined</mat-icon>
  </button>
</div>
